/**
 * Newsletter block entry.
 *
 * Importing the SCSS here makes Vite bundle the block's CSS alongside its JS.
 *
 * Submission itself needs no JS — it's a plain POST straight to Brevo's own
 * endpoint. The form's `target` just points at a hidden iframe instead of
 * navigating the whole page there, so once that POST completes this script
 * can swap in a local success message instead of leaving the visitor on
 * Brevo's unstyled, raw-JSON response page.
 */

import './index.scss';

const newsletters = document.querySelectorAll('.newsletter');

if (newsletters.length) {
	const forms = document.querySelectorAll('[data-newsletter-form]');

	forms.forEach((form) => {
		const success = form.parentElement?.querySelector('[data-newsletter-success]');
		const targetIframe = document.querySelector(`iframe[name="${form.target}"]`);

		if (!success || !targetIframe) return;

		let submitted = false;

		form.addEventListener('submit', () => {
			submitted = true;
		});

		targetIframe.addEventListener('load', () => {
			if (!submitted) return;

			form.hidden = true;
			success.hidden = false;
		});
	});
}
